import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc.js';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
export class PriceUtils {
    static format(price, { accuracy } = { accuracy: 2 }) {
        return new Intl.NumberFormat(PriceUtils.getLocaleForCurrency(price.currency), {
            style: 'currency',
            currency: price.currency,
            minimumFractionDigits: accuracy,
            currencyDisplay: 'narrowSymbol',
        }).format(price.value);
    }
    static getLocaleForCurrency(currency) {
        switch (currency) {
            case 'CAD':
                return 'en-CA';
            case 'USD':
                return 'en-US';
            default:
                return 'fr-FR';
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJpY2UudXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvcHJpY2UtdXRpbHMvcHJpY2UudXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLE1BQU0sT0FBTyxDQUFBO0FBQ3pCLE9BQU8sYUFBYSxNQUFNLCtCQUErQixDQUFBO0FBQ3pELE9BQU8sUUFBUSxNQUFNLDBCQUEwQixDQUFBO0FBQy9DLE9BQU8sR0FBRyxNQUFNLHFCQUFxQixDQUFBO0FBRXJDLEtBQUssQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUE7QUFDakIsS0FBSyxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsQ0FBQTtBQUN0QixLQUFLLENBQUMsTUFBTSxDQUFDLGFBQWEsQ0FBQyxDQUFBO0FBVTNCLE1BQU0sT0FBTyxVQUFVO0lBQ3JCLE1BQU0sQ0FBQyxNQUFNLENBQUMsS0FBWSxFQUFFLEVBQUUsUUFBUSxLQUFvQixFQUFFLFFBQVEsRUFBRSxDQUFDLEVBQUU7UUFDdkUsT0FBTyxJQUFJLElBQUksQ0FBQyxZQUFZLENBQUMsVUFBVSxDQUFDLG9CQUFvQixDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsRUFBRTtZQUM1RSxLQUFLLEVBQUUsVUFBVTtZQUNqQixRQUFRLEVBQUUsS0FBSyxDQUFDLFFBQVE7WUFDeEIscUJBQXFCLEVBQUUsUUFBUTtZQUMvQixlQUFlLEVBQUUsY0FBYztTQUNoQyxDQUFDLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQTtJQUN4QixDQUFDO0lBRU8sTUFBTSxDQUFDLG9CQUFvQixDQUFDLFFBQWdCO1FBQ2xELFFBQVEsUUFBUSxFQUFFLENBQUM7WUFDakIsS0FBSyxLQUFLO2dCQUNSLE9BQU8sT0FBTyxDQUFBO1lBQ2hCLEtBQUssS0FBSztnQkFDUixPQUFPLE9BQU8sQ0FBQTtZQUNoQjtnQkFDRSxPQUFPLE9BQU8sQ0FBQTtRQUNsQixDQUFDO0lBQ0gsQ0FBQztDQUNGIn0=